module.exports = __webpack_public_path__ + "94cefc4a8095b98a068ca535a5a20a72.png";